import { Chip, Tooltip } from "@heroui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faDroplet, faLeaf } from "@fortawesome/free-solid-svg-icons";
import useFeatureFlag from "@/lib/featureFlags/useFeatureFlags";
import {
    tierHasNitrogenInsights,
    tierHasWaterInsights,
} from "@/lib/utils/enrollment";

function ActivityChip({
    icon,
    label,
    active,
    activeColor,
}: {
    icon: IconDefinition;
    label: string;
    active: boolean;
    activeColor: "success" | "primary";
}) {
    const tooltip = `${label}: ${active ? "Active" : "Inactive"}`;

    return (
        <Tooltip
            closeDelay={0}
            content={<div className="text-xs">{tooltip}</div>}
        >
            <Chip
                radius="sm"
                size="sm"
                variant="flat"
                color={active ? activeColor : "default"}
                aria-label={tooltip}
                classNames={{
                    base: "text-[0.6rem]",
                    content: "p-[0.15rem]",
                }}
            >
                <FontAwesomeIcon icon={icon} />
            </Chip>
        </Tooltip>
    );
}

function InsightsActivityChip({
    enrollmentTier,
    insightsActive,
    waterInsightsActive,
}: {
    enrollmentTier?: number;
    insightsActive: boolean;
    waterInsightsActive?: boolean;
}) {
    const { irrigationEnabled } = useFeatureFlag();
    const showNitrogen = tierHasNitrogenInsights(enrollmentTier);
    const showWater =
        waterInsightsActive === true ||
        (irrigationEnabled &&
            waterInsightsActive !== undefined &&
            tierHasWaterInsights(enrollmentTier));

    if (!showNitrogen && !showWater) {
        return null;
    }

    return (
        <>
            {showNitrogen && (
                <ActivityChip
                    icon={faLeaf}
                    label="Nitrogen Insights"
                    active={insightsActive}
                    activeColor="success"
                />
            )}
            {showWater && (
                <ActivityChip
                    icon={faDroplet}
                    label="Water Insights"
                    active={!!waterInsightsActive}
                    activeColor="primary"
                />
            )}
        </>
    );
}

export default InsightsActivityChip;
